import { Radio } from 'antd';

export const QaSpecBoolean = (props) => {
  const { checked, style = {}, ...otherProps } = props;

  return (
    <Radio.Group style={{ display: 'flex', ...style }} {...otherProps}>
      <Radio value='Yes'>Yes</Radio>
      <Radio value='No'>No</Radio>
    </Radio.Group>
  );
};

export const QaSpecBooleanTrueFalse = (props) => {
  const { checked, style = {}, ...otherProps } = props;

  return (
    <Radio.Group style={{ display: 'flex', ...style }} {...otherProps}>
      <Radio value={true}>Yes</Radio>
      <Radio value={false}>No</Radio>
    </Radio.Group>
  );
};